import React from 'react';
import { motion } from 'framer-motion';
import { FileText, Zap, Globe, BookOpen, ShieldCheck, CreditCard } from 'lucide-react';
import { CtaButton } from './CtaButton';
export function HeroSection() {
  return <section className="relative pt-20 pb-16 md:pt-32 md:pb-24 px-4 overflow-hidden" data-id="element-133">
      {/* Background glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-brand/10 blur-[120px] rounded-full pointer-events-none" data-id="element-134" />

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-135">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} data-id="element-136">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-surface border border-border text-brand font-semibold mb-8" data-id="element-137">
            <span className="text-xl" data-id="element-138">🛴</span> SABER-DIGITAL™
          </div>

          <p className="text-brand font-bold tracking-wide uppercase text-sm md:text-base mb-6" data-id="element-139">
            Todo lo que necesitás saber sobre tu scooter eléctrico.
            <span className="text-white ml-1" data-id="element-140">Listo. Desde hoy.</span>
          </p>

          <h1 className="text-4xl md:text-6xl font-heading font-bold leading-tight mb-6" data-id="element-141">
            MegaPack Scooter Eléctrico <br data-id="element-142" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-brand to-emerald-400" data-id="element-143">
              Combo Completo
            </span>
          </h1>

          <p className="text-xl md:text-2xl text-gray-300 font-medium mb-6" data-id="element-144">
            El sistema N°1 para usuarios de scooters eléctricos en Argentina —
            Mecánica + Desarme + Fallas + Mantenimiento — Todo en un solo lugar
          </p>

          <p className="text-lg text-muted mb-10 max-w-3xl mx-auto" data-id="element-145">
            Diagnóstico + reparación + mantenimiento preventivo listos para
            usar. Sin buscar en YouTube. Sin gastar en técnicos innecesarios.
            Sin quedarte tirado en la calle.
          </p>

          {/* Product Mockup */}
          <motion.div className="mb-12" animate={{
          y: [0, -10, 0]
        }} transition={{
          duration: 4,
          repeat: Infinity,
          ease: 'easeInOut'
        }} data-id="element-146">
            <img src="https://cdn.magicpatterns.com/uploads/anVN8Cx6D3Vs7h7gArRsgh/scooter_electrico_seleccionado.png" alt="SABER-DIGITAL MegaPack Scooter Eléctrico — Combo Completo" className="mx-auto max-w-full w-[600px] drop-shadow-[0_0_40px_rgba(0,230,118,0.2)]" data-id="element-147" />
          </motion.div>

          {/* Feature Badges */}
          <div className="flex flex-wrap justify-center gap-3 mb-12" data-id="element-148">
            <Badge icon={<FileText size={16} data-id="element-150" />} text="100% PDF" data-id="element-149" />
            <Badge icon={<Zap size={16} className="text-accent" data-id="element-152" />} text="Acceso en 5 min" data-id="element-151" />
            <Badge icon={<Globe size={16} className="text-blue-400" data-id="element-154" />} text="Para Argentina/LatAm" data-id="element-153" />
            <Badge icon={<BookOpen size={16} className="text-brand" data-id="element-156" />} text="3 eBooks completos" data-id="element-155" />
          </div>

          <div className="flex flex-col items-center gap-4" data-id="element-157">
            <CtaButton className="text-xl px-10 py-5" data-id="element-158">
              <span className="mr-2" data-id="element-159">🛴</span> → QUIERO MI MEGAPACK AHORA
            </CtaButton>

            <div className="flex items-center gap-4 text-sm text-muted mt-2" data-id="element-160">
              <span className="flex items-center gap-1" data-id="element-161">
                <ShieldCheck size={16} className="text-brand" data-id="element-162" /> Pago seguro
              </span>
              <span className="flex items-center gap-1" data-id="element-163">
                <CreditCard size={16} className="text-blue-400" data-id="element-164" /> Mercado Pago
              </span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}
function Badge({
  icon,
  text
}: {
  icon: React.ReactNode;
  text: string;
}) {
  return <div className="flex items-center gap-2 bg-surface border border-border rounded-full px-4 py-2 text-sm font-medium" data-id="element-165">
      {icon}
      <span data-id="element-166">{text}</span>
    </div>;
}